/** Public URL for a completed social post. Matches the backend `buildSocialPostUrl` except
 * for Facebook: here every post kind links to `facebook.com/<provider_post_id>` (the id is
 * the only thing the UI has; the backend email uses kind-specific URLs). */
export function resolvePublishedPostUrl({
  platform,
  status,
  providerPostId,
  username,
}: {
  platform?: string | null;
  status?: string | null;
  providerPostId?: string | null;
  username?: string | null;
}): string | null {
  if (platform === 'facebook' && status !== 'published') return null;
  if (platform === 'tiktok' && status !== 'published') return null;
  return buildSocialPostUrl({
    platform, providerPostId, username,
  });
}

export function buildSocialPostUrl({
  platform,
  providerPostId,
  username,
}: {
  platform?: string | null;
  providerPostId?: string | null;
  username?: string | null;
}): string | null {
  if (platform === 'facebook') {
    // Every kind (reel, video, photos) resolves from the public post id.
    return providerPostId
      ? `https://www.facebook.com/${encodeURIComponent(providerPostId)}`
      : null;
  }
  if (platform === 'youtube' && providerPostId) {
    return `https://www.youtube.com/watch?v=${encodeURIComponent(providerPostId)}`;
  }
  if (platform === 'instagram' && username) {
    return `https://www.instagram.com/${encodeURIComponent(username)}/`;
  }
  if (platform === 'tiktok' && username && providerPostId) {
    return `https://www.tiktok.com/@${encodeURIComponent(username)}/video/${encodeURIComponent(providerPostId)}`;
  }
  return null;
}
